import { PaginationState } from '@tanstack/react-table';
import { SessionStorage } from '@va/util/helpers';
import { useCallback } from 'react';

const paginationStorageKey = (id: string) => `visa-pagination-${id}`;

export const useSessionStoragePagination = (id?: string) => {
  const getStoredPagination = useCallback((): PaginationState | undefined => {
    if (!id) return;
    const storageItem = SessionStorage.getItem(paginationStorageKey(id));
    try {
      if (storageItem) {
        return JSON.parse(storageItem);
      }
    } catch (error) {
      console.error(error);
    }
    return undefined;
  }, [id]);

  const getStoredPageSize = useCallback(() => getStoredPagination()?.pageSize, [getStoredPagination]);

  const getStoredPageIndex = useCallback(() => getStoredPagination()?.pageIndex, [getStoredPagination]);

  const storePageSize = useCallback(
    (pageSize: number) => {
      if (!id) return;
      const current = getStoredPagination() || {};
      const updated = { ...current, pageSize };
      SessionStorage.setItem(paginationStorageKey(id), JSON.stringify(updated));
    },
    [id, getStoredPagination],
  );

  const storePageIndex = useCallback(
    (pageIndex: number) => {
      if (!id) return;
      const current = getStoredPagination() || {};
      const updated = { ...current, pageIndex };
      SessionStorage.setItem(paginationStorageKey(id), JSON.stringify(updated));
    },
    [id, getStoredPagination],
  );

  return { getStoredPageSize, storePageSize, getStoredPageIndex, storePageIndex };
};
